"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = exports.StyledIndicatorWrapper = exports.StyledIndicatorContainer = exports.StyledIndicator = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var componentName = _config.DefaultConfig.componentName;
var StyledIndicatorWrapper = exports.StyledIndicatorWrapper = _styledComponents["default"].div.attrs({
  className: "".concat(componentName)
}).withConfig({
  displayName: "styled-password-indicator__StyledIndicatorWrapper",
  componentId: "sc-1dkqpj1-0"
})(["display:flex;flex-wrap:wrap;"]);
var StyledIndicatorContainer = exports.StyledIndicatorContainer = _styledComponents["default"].div.attrs({
  className: "".concat(componentName, "__indicator-wrapper"),
  'data-testid': "".concat(componentName, "__indicator-wrapper")
}).withConfig({
  displayName: "styled-password-indicator__StyledIndicatorContainer",
  componentId: "sc-1dkqpj1-1"
})(["display:flex;flex:1 1 100%;margin-bottom:var(--spacing-global-space2);"]);

// Data testid added via props to add in dynamic
var StyledIndicator = exports.StyledIndicator = _styledComponents["default"].span.attrs({
  className: "".concat(componentName, "__indicator")
}).withConfig({
  displayName: "styled-password-indicator__StyledIndicator",
  componentId: "sc-1dkqpj1-2"
})(["margin-right:var(--spacing-global-space3);flex:1 1 25%;background-color:", ";height:var(--spacing-global-space2);:last-child{margin-right:0px;}"], function (_ref) {
  var colour = _ref.colour;
  return colour || "var(--color-global-grey500)";
});
var StyledText = exports.StyledText = _styledComponents["default"].span.attrs({
  className: "".concat(componentName, "__indicator-text"),
  'data-testid': "".concat(componentName, "__indicator-text")
}).withConfig({
  displayName: "styled-password-indicator__StyledText",
  componentId: "sc-1dkqpj1-3"
})(["font-size:var(--font-size-m1);line-height:var(--font-line-height-m1);font-weight:var(--font-weight-heading);margin-bottom:var(--spacing-global-space2);order:1;color:", ";"], function (_ref2) {
  var colour = _ref2.colour;
  return colour;
});